import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import React from "react";
import styled from "@emotion/styled";
import {css} from "@mui/material";
import { DayStatus, type buildStreakStatus} from "modules/utils/streak";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import {IconMulligan} from "components/Icons/IconMulliigan";

interface ISelectResult {
	status?: DayStatus;
}

const SelectResultWrapper = styled.div<ISelectResult>`
	width: 24px;
	height: 24px;
	border-radius: 50%;
	background: #ffffff;
	z-index: 3;
	display: flex;
	flex-shrink: 0;
	flex-grow: 0;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	font-weight: 700;
	color: #121212;
	position: relative;

	div {
		display: flex;
		align-items: center;
		justify-content: center;
		line-height: 24px;
		vertical-align: middle;
	}
	svg {
		width: 20px;
		height: 20px;
		color: currentColor;
	}

	${(props) =>
		props.status &&
		{
			[DayStatus.STREAK_ONE]: css`
				background: #a3dd9e;
			`,
			[DayStatus.STREAK_TWO]: css`
				background: #a3dd9e;
			`,
			[DayStatus.ENDS]: css`
				background: #f03b3b;
				color: #ffffff;
			`,
			[DayStatus.CONTINUES]: css`
				background: #6d747d;
				color: #fff;

				svg {
					width: 100%;
					height: 100%;
				}
			`,
			[DayStatus.MULLIGAN]: css`
				background: transparent;
				color: #58a3ff;

				&:before {
					position: absolute;
					left: 50%;
					top: 50%;
					content: "";
					width: 15px;
					height: 15px;
					background: #282f38;
					transform: translate(-50%, -50%);
					border-radius: 50%;
					z-index: 0;
				}
				svg {
					width: 24px;
					height: 24px;
					position: relative;
					z-index: 1;
				}
			`,
			[DayStatus.LOCKED]: css`
				background: #f6c844;
				svg {
					color: #121212;
					width: 16px;
					height: 16px;
				}
			`,
			[DayStatus.PICKED]: css`
				background: #f6c844;
				svg {
					color: #121212;
					width: 16px;
					height: 16px;
				}
			`,
			[DayStatus.MAKE_A_PICK]: css`
				background: #f6c844;
				svg {
					color: #121212;
					width: 16px;
					height: 16px;
				}
			`,
		}[props.status]}
`;

interface IProps {
	pick?: {
		result: ReturnType<typeof buildStreakStatus>;
		streak: number | null;
	} | null;
}

export const StreakBadge: React.FC<IProps> = ({pick}) => {
	if (!pick) {
		return null;
	}

	const result = pick.result;
	const streak = pick.streak || 0;

	return (
		<SelectResultWrapper status={result}>
			{
				{
					[DayStatus.STREAK_ONE]: <div>{streak}</div>,
					[DayStatus.STREAK_TWO]: <div>{streak}</div>,
					[DayStatus.ENDS]: <CloseRoundedIcon />,
					[DayStatus.CONTINUES]: <RemoveRoundedIcon />,
					[DayStatus.MULLIGAN]: <IconMulligan />,
					[DayStatus.MAKE_A_PICK]: <LockRoundedIcon />,
					[DayStatus.LOCKED]: <LockRoundedIcon />,
					[DayStatus.PICKED]: <LockRoundedIcon />,
				}[result]
			}
		</SelectResultWrapper>
	);
};
